module.exports = __webpack_public_path__ + "static/media/phoenix.6f07e411.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/geojson/phoenix.json
// module id = 923
// module chunks = 27